import React from 'react';
import { LandingPage } from './pages/LandingPage';
function App() {
  return <LandingPage data-id="element-0" />;
}
export { App };